import {useEffect } from 'react';
import socket from '../../socket/socket';

export const useSocketEvent = (eventName: string, callback: (data: any, ...args: any[]) => void, ...args: any[]) => {

  useEffect(() => {
    
    const wrappedCallback = (data: any) => {
      callback(data, ...args);
    };

    socket.on(eventName, wrappedCallback);
  
    return () => {
      socket.off(eventName, wrappedCallback);
    };
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket, eventName, callback, args]);
};



